(() => {
  if (customElements.get('nikuya-engineering')) return;

  class NikuyaEngineering extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.controller) return;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      if (!tabs.length || tabs.length > 4 || tabs.length !== panels.length) return;
      if (tabs.some((tab, index) => tab.getAttribute('aria-controls') !== panels[index].id)) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const focusTab = (index) => {
        tabs.forEach((tab, i) => { tab.tabIndex = i === index ? 0 : -1; });
        tabs[index].focus();
      };
      const activate = (index) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index), options);
        tab.addEventListener('keydown', (event) => {
          let next;
          switch (event.key) {
            case 'ArrowLeft': next = (index + tabs.length - 1) % tabs.length; break;
            case 'ArrowRight': next = (index + 1) % tabs.length; break;
            case 'Home': next = 0; break;
            case 'End': next = tabs.length - 1; break;
            case 'Enter':
            case ' ':
              event.preventDefault();
              activate(index);
              return;
            default: return;
          }
          event.preventDefault();
          focusTab(next);
        }, options);
      });
      this.addEventListener('shopify:block:select', (event) => {
        const index = panels.findIndex((panel) => panel.dataset.blockId === event.detail?.blockId);
        if (index < 0) return;
        activate(index);
        panels[index].scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }, options);
      activate(0);
      tabs.forEach((tab) => { tab.disabled = false; });
      this.dataset.enhancement = 'ready';
    }

    teardown() {
      this.controller?.abort();
      this.controller = null;
      this.dataset.enhancement = 'pending';
      this.querySelectorAll('[role="tab"]').forEach((tab) => { tab.disabled = true; });
    }

    disconnectedCallback() {
      this.teardown();
    }
  }

  customElements.define('nikuya-engineering', NikuyaEngineering);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('nikuya-engineering').forEach((section) => section.initialize());
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('nikuya-engineering').forEach((section) => section.teardown());
  });
})();
